import React, { FC } from 'react'
import TSvgProps from './type/svgPropsType'

const PictureOffIcon: FC<TSvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      aria-label="사진 비활성화"
      {...props}
    >
      <desc>사진 비활성화</desc>
      <path fill="none" d="M0 0h20v20H0z"></path>
      <g fill="none" stroke="#ccc">
        <rect width="15" height="11" x="2.5" y="5" stroke="none" rx="2"></rect>
        <rect width="14" height="10" x="3" y="5.5" rx="1.5"></rect>
      </g>
      <g fill="#ccc">
        <path
          d="M10 7.5H2a.491.491 0 01-.447-.276A.491.491 0 011.6 6.7l4-5.333a.496.496 0 01.4-.2c.159 0 .305.073.4.2l4 5.333a.49.49 0 01.047.524A.491.491 0 0110 7.5z"
          transform="translate(2.5 8)"
        ></path>
        <path
          d="M6 1.667L2 7h8L6.002 1.667zm0-1c.3 0 .6.133.8.4l4 5.333A1 1 0 0110 8H2a1 1 0 01-.8-1.6l4-5.333c.2-.267.5-.4.8-.4z"
          transform="translate(2.5 8)"
        ></path>
        <path
          d="M5.08 4.5H1.92a.49.49 0 01-.443-.27.492.492 0 01.034-.517l1.58-2.256a.494.494 0 01.409-.213c.165 0 .315.078.41.213l1.579 2.256c.109.156.122.35.034.518a.492.492 0 01-.444.269z"
          transform="translate(10.5 11)"
        ></path>
        <path
          d="M3.5 1.744L1.92 4h3.16zm0-1c.31 0 .62.142.82.426l1.579 2.257A1 1 0 015.079 5H1.921a1 1 0 01-.82-1.573l1.58-2.257A.993.993 0 013.5.744z"
          transform="translate(10.5 11)"
        ></path>
        <circle cx="12.5" cy="8.5" r="0.5"></circle>
      </g>
    </svg>
  )
}

export default PictureOffIcon
